import React, { useMemo } from 'react'
import { CalendarSelection, Day } from '../../../../types/calendar.types'

type MonthlyCalendarProps = {
  selection: CalendarSelection
  onSelectionChange: (selection: CalendarSelection) => void
  availableMonthlyDays: Day[]
  handleDisabledDayClick: () => void
}

export const MonthlyCalendar: React.FC<MonthlyCalendarProps> = ({
  selection,
  onSelectionChange,
  availableMonthlyDays = [],
  handleDisabledDayClick
}) => {
  // Generate default monthly days if none provided
  const generateMonthlyDays = () => {
    return Array.from({ length: 28 }, (_, i) => ({
      day: i + 1,
      isEnabled: availableMonthlyDays.some((day) => day.day === i + 1),
      isSelected: i + 1 === selection.value
    }))
  }

  const calendarDays = useMemo(() => generateMonthlyDays(), [selection, availableMonthlyDays])

  const handleDaySelect = (day: number) => {
    onSelectionChange({
      ...selection,
      value: day
    })
  }

  return (
    <div className='px-5'>
      {/* Calendar Grid */}
      <div
        className='grid grid-cols-5 gap-y-6 w-full'
        style={{
          gridTemplateColumns: 'repeat(5, 16px)',
          gridTemplateRows: 'repeat(auto-fit, 20px)',
          justifyContent: 'space-between'
        }}
      >
        {calendarDays.map(({ day, isEnabled, isSelected }) => {
          if (isSelected) {
            return (
              <div
                key={day}
                className='w-4 h-5 relative flex items-center justify-center text-[14px] font-[700] cursor-pointer mx-auto'
                onClick={() => handleDaySelect(day)}
              >
                <div className='absolute inset-0 bg-[#232323] rounded-full w-8 h-8 top-[-5.5px] -left-[8px]'></div>
                <span className='relative z-10 text-white'>{day}</span>
              </div>
            )
          }

          return (
            <div
              key={day}
              className={`w-4 h-5 flex items-center justify-center text-[14px] font-[500] cursor-pointer mx-auto ${
                isEnabled ? 'text-[#232323]' : 'text-[#9CA3AF]'
              }`}
              style={{ minWidth: 0, maxWidth: '100%' }}
              onClick={() => (isEnabled ? handleDaySelect(day) : handleDisabledDayClick())}
            >
              {day}
            </div>
          )
        })}
      </div>
    </div>
  )
}
